import { Component, OnInit, Input, ElementRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '../../../shared/models/WidgetSearch';
import { DashboardService } from '../../../shared/services/dashboard.service';
import { GlobalsService } from '../../../shared/services/globals.service';
//import { Item } from '@progress/kendo-angular-grid/dist/es2015/data/data.iterators';
import { Subscription } from 'rxjs';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';

import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'cp-show-customer-statistics',
    templateUrl: './show-customer-statistics.component.html',
    styleUrls: ['./show-customer-statistics.component.scss']
})
export class ShowCustomerStatisticsComponent  implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    constructor(private globals: GlobalsService, private svc_data: DashboardService, private  el: ElementRef, qry_rd: DQOIReferenceDataQuery) {
        this.qry_rd = qry_rd;
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            this.referenceData = data;
        });
        this.subscriptions.push(svc_data.refreshTrigger$.subscribe(
            refresh => {
                if (this.searchParam) {
                    this.search(this.searchParam);
                }
            }));
    }

    customerFilters: any;
    acctClassFilters: any;
    srvConstFilters: any;
    divisionFilters: any;
    regionFilters: any;
    onCallRegionFilters: any;

    @Input() chartType: string = 'donut';
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);
    subs_dataRefUpdated: Subscription;
    loaderError: boolean = false;

    public dashboardQuery: DashboardQueries = DashboardQueries.showCustomerStatistics;
    widgetQuery: DashboardQueries = DashboardQueries.showCustomerStatistics;
    searchFilters: widgetFilters[] = [widgetFilters.customer,
                                      widgetFilters.class,
                                      widgetFilters.svcConst,
                                      widgetFilters.state,
                                      widgetFilters.onCallRegion,
                                      widgetFilters.divisions,
                                      widgetFilters.regions,
                                      widgetFilters.dateRange];

    subs_dataRef: Subscription;
    qry_rd: DQOIReferenceDataQuery;
    referenceData: DQOIReferenceData;

    show: boolean = false;
    searchParam: WidgetSearch;
    data: any;

    ngOnInit() {
        if (this.inputSearchParams) {
            this.searchParam = this.inputSearchParams;
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }

    search(searchParam: WidgetSearch) {
        this.hideError();
        this.searchParam = searchParam;
        this.searchParams.emit(searchParam);
        this.searchParam.userId = this.globals.userId;
        this.showSpinner();
        if (this.searchParam.customSearch || this.searchParam.emptySearch) {
            this.show = false;
            this.showSpinner();

            this.searchParam.isConstruction = null;
            //srvConstInt = 2 means the user selected Construction dispatches only
            if (this.searchParam.srvConstInt != null) {
               this.searchParam.isConstruction = this.searchParam.srvConstInt == 2;
            }

            this.svc_data.getDashboardQuery(this.widgetQuery, this.searchParam).subscribe(data => {
                this.data = data.result;
                this.show = false;
                this.setFilteredItemsDisplay();
                this.hideSpinner();
            },
                error => this.handleNetworkError(error));
        } else {
            this.show = true;
            this.hideSpinner();
        }
    }

    handleNetworkError(error) {

        this.hideSpinner();
        this.showError();
    }

    showSpinner() {
        this.loaderState.emit(true);
        $(this.el.nativeElement).closest('.cp-widget').find('.jarviswidget-loader').first().css('display', 'block');
    }

    hideSpinner() {
        this.loaderState.emit(false);
        $(this.el.nativeElement).closest('.cp-widget').find('.jarviswidget-loader').css('display', 'none');
    }

    showError() {
        this.loaderError = true;
        this.loaderErrorState.emit(this.loaderError);
    }

    hideError() {
        this.loaderError = false;
        this.loaderErrorState.emit(this.loaderError);
    }

    public onToggle(): void {
        this.show = !this.show;
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }

    setFilteredItemsDisplay() {
        this.customerFilters = CommonFunctions.findInObjArr(this.referenceData.customers, this.searchParam.customerIds);
        this.acctClassFilters = CommonFunctions.findInObjArr(this.referenceData.accountClasses, this.searchParam.classIds);
        this.srvConstFilters = CommonFunctions.findInObjArr(this.referenceData.srvConst, this.searchParam.srvConstInt);
        this.divisionFilters = CommonFunctions.findInObjArr(this.referenceData.divisions, this.searchParam.divisionIds);
        this.regionFilters = CommonFunctions.findInObjArr(this.referenceData.regions, this.searchParam.regionIds);
        this.onCallRegionFilters = CommonFunctions.findInObjArr(this.referenceData.onCallRegions, this.searchParam.onCallRegions);
    }
}
